import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const WorkSection: React.FC = () => {
  const works = [
    { title: 'Free Education', desc: 'We establish schools, colleges, and study centres to empower youth and foster growth across diverse regions.' },
    { title: 'Skill Development', desc: 'Providing vocational training and certification programs to empower individuals and enhance their opportunities for a better future.' },
    { title: 'Healthcare Support', desc: 'Promoting health awareness and providing essential medical services to support communities.' },
    { title: 'Women Empowerment', desc: 'Spearheading initiatives and programs to promote gender equality and empower women for growth and opportunity.' },
  ];

  return (
    <section className="work-section py-5">
      <Container>
        <h2 className="text-center mb-5 section-title">What We Do</h2>
        <Row className="justify-content-center">
          {works.map((work, index) => (
            <Col md={6} lg={3} key={index} className="mb-4">
              <div className="work-box fade-in-up">
                <h3 className="work-title">{work.title}</h3>
                <p className="work-desc">{work.desc}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default WorkSection;
